/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { InputEnumPropertyOption } from "./InputEnumPropertyOption";
export const InputConfig = core.serialization.object({
    options: core.serialization.list(InputEnumPropertyOption),
});
